// @ts-nocheck
import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { useSelector } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  HashRouter,
  useLocation,
  BrowserRouter,
} from 'react-router-dom';
import { useTheme } from '@mui/material';
import UserConfirmationPrompt from '../components/Common/UserConfirmationPrompt';
import { CoreUtils } from '../utils/Utils';
import { AppConfig } from '../config/index';

import Login from '../pages/Login';
import Organization from '../pages/Organization';
import Layout from '../pages/Layout';
import PageNotFound from '../pages/PageNotFound';
import PageLevelLoader from '../components/Common/PageLevelLoader';

const PrivateRoute = ({ component: Component, isLoggedIn, loading, realm }) => (
  <Route
    render={(props) => {
      if (
        !isLoggedIn &&
        AppConfig.keycloakLogin === true &&
        realm &&
        loading
      ) {
        return <PageLevelLoader />;
      }
      if (!isLoggedIn) {
        if (AppConfig.keycloakLogin === true && !realm) {
          return <Redirect to="/org" />;
        }
        return <Redirect to="/login" />;
      }
      return <Component {...props} loading={loading} />;
    }}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  realm: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

PrivateRoute.defaultProps = {
  realm: null,
};

const PROTOTYPE_USERNAMES = ['sumitsky03'];

// Rendered via srcDoc so server frame headers (X-Frame-Options) don't apply;
// the sandbox (no allow-same-origin) isolates it from the app's tokens/storage.
const PrototypeFrame = () => {
  const [html, setHtml] = React.useState(null);
  const [failed, setFailed] = React.useState(false);

  React.useEffect(() => {
    fetch('/demo/regradar-prototype.html')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load prototype');
        return res.text();
      })
      .then(setHtml)
      .catch(() => setFailed(true));
  }, []);

  if (failed) return <PageNotFound />;
  if (html === null) return <PageLevelLoader />;

  return (
    <iframe
      title="RegRadar Prototype"
      srcDoc={html}
      sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 0,
      }}
    />
  );
};

export const AppRoutes = ({ loading, isLoggedIn, realm }) => {
  const { userConfirmationPrompt } = UserConfirmationPrompt(useTheme());
  const username = useSelector((state) => state.app?.auth?.user?.username);

  if (isLoggedIn && loading) {
    return <PageLevelLoader />;
  }

  if (isLoggedIn && PROTOTYPE_USERNAMES.includes(username)) {
    return <PrototypeFrame />;
  }

  return (
    <BrowserRouter>
      <React.Suspense fallback={<PageLevelLoader />}>
        <Switch>
          {!isLoggedIn && AppConfig.keycloakLogin === true && (
            <Route path="/org" component={Organization} />
          )}
          {!isLoggedIn && AppConfig.keycloakLogin !== true && (
            <Route path="/login" component={Login} />
          )}

          <PrivateRoute
            path="/*"
            isLoggedIn={isLoggedIn}
            realm={realm}
            component={Layout}
            loading={loading}
          />
          <Route
            path="*"
            name="Not Found"
            render={(props) => <PageNotFound {...props} />}
          />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};
